import { useDocumentTitle } from "@/i18n";
import { ForgotPasswordPageView } from "./_components";

const ForgotPasswordPage = () => {
  useDocumentTitle("forgotPassword.page");
  return <ForgotPasswordPageView />;
};

export default ForgotPasswordPage;
